var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { t } from '@mp/locale';
function canShowPrevious(times, earliestPossibleDate) {
    if (times.length) {
        var initialDate = times[0];
        return (earliestPossibleDate &&
            earliestPossibleDate.getTime() < initialDate.date.getTime());
    }
    return false;
}
function canShowNext(times, earliestPossibleDate, step) {
    if (step === void 0) { step = times.length; }
    var SCHEDULE_LIMIT = 41; //+6 weeks - 1 day.
    if (times.length) {
        var lastDate = times[step - 1];
        if (earliestPossibleDate) {
            var lastPossibleDate = new Date(earliestPossibleDate);
            lastPossibleDate.setDate(earliestPossibleDate.getDate() + SCHEDULE_LIMIT);
            return lastPossibleDate.getTime() > lastDate.date.getTime();
        }
        return true;
    }
    return false;
}
function schedulerLabel(step, times) {
    if (times.length) {
        var initialDate = times[0];
        var lastDate = times[step - 1];
        return (initialDate.formatted.month +
            " " +
            initialDate.formatted.day +
            " - " +
            lastDate.formatted.month +
            " " +
            lastDate.formatted.day);
    }
    return "";
}
export default function SchedulerWeekNav(_a) {
    var earliestPossibleDate = _a.earliestPossibleDate, changeWeek = _a.changeWeek, times = _a.times;
    return (_jsxs("div", __assign({ className: "mp-scheduler-week-nav" }, { children: [_jsx("button", __assign({ className: classnames("mp-week-nav-prev", "show-md", {
                    "is-disabled": !canShowPrevious(times, earliestPossibleDate),
                }), id: "mp-scheduler-week-prev-long", onClick: function () { return changeWeek({ direction: "backward", times: times, step: 7 }); }, type: "button", disabled: !canShowPrevious(times, earliestPossibleDate), "aria-label": t("COMMON.ACTIONS.back") }, { children: _jsx("i", { className: "ico ico-chevron-left" }) })), _jsx("button", __assign({ className: classnames("mp-week-nav-prev hide-md", {
                    "is-disabled": !canShowPrevious(times, earliestPossibleDate),
                }), id: "mp-scheduler-week-prev-long-sm", onClick: function () { return changeWeek({ direction: "backward", times: times, step: 4 }); }, type: "button", disabled: !canShowPrevious(times, earliestPossibleDate), "aria-label": t("COMMON.ACTIONS.back") }, { children: _jsx("i", { className: "ico ico-chevron-left" }) })), _jsx("div", __assign({ className: "mp-week-nav-label show-md" }, { children: schedulerLabel(7, times) })), _jsx("div", __assign({ className: "mp-week-nav-label hide-md" }, { children: schedulerLabel(4, times) })), _jsx("button", __assign({ className: classnames("mp-week-nav-next", "show-md", {
                    "is-disabled": !canShowNext(times, earliestPossibleDate),
                }), onClick: function () { return changeWeek({ direction: "forward", times: times, step: 7 }); }, id: "mp-scheduler-week-next-long", type: "button", disabled: !canShowNext(times, earliestPossibleDate), "aria-label": t("COMMON.ACTIONS.next") }, { children: _jsx("i", { className: "ico ico-chevron-right" }) })), _jsx("button", __assign({ className: classnames("mp-week-nav-next", "hide-md", {
                    "is-disabled": !canShowNext(times, earliestPossibleDate, 4),
                }), id: "mp-scheduler-week-next-long-sm", onClick: function () { return changeWeek({ direction: "forward", times: times, step: 4 }); }, type: "button", disabled: !canShowNext(times, earliestPossibleDate, 4), "aria-label": t("COMMON.ACTIONS.next") }, { children: _jsx("i", { className: "ico ico-chevron-right" }) }))] })));
}
